import React from 'react';
import { ChatWindow } from '../components/ui/ChatWindow';
import { useCopilotChatSuggestions } from '@copilotkit/react-ui';
const Agent = () => {
    useCopilotChatSuggestions({
        instructions: `Provide helpful conversation starters for Outlook meeting management. 
            RULES:
            1. Only suggest text prompts that start natural conversations
            2. DO NOT suggest direct tool calls or function invocations
            3. Suggestions should be user-friendly questions or requests
            4. Let the AI assistant guide users through the actual tool usage
            5. Focus on the specific meeting management capabilities available: creating, listing, updating, and deleting Outlook meetings
            6. Suggestions should relate to real-world scenarios users face with calendar management
            7. Keep suggestions conversational and helpful for busy professionals`,
        minSuggestions: 3,
        maxSuggestions: 5,
    }, []);
    return (React.createElement(ChatWindow, null));
};
export default Agent;
